import { render, staticRenderFns } from "./EditWebsitePassword.vue?vue&type=template&id=87345e36&scoped=true&"
import script from "./EditWebsitePassword.vue?vue&type=script&lang=ts&"
export * from "./EditWebsitePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87345e36",
  null
  
)

export default component.exports